import Page404 from "./Page404.vue";

export default {
  path: "/page-404",
  name: "Page404",
  component: Page404,
  meta: {
    breadcrumb: "settings",
    layout: "Restricted"
  }
};
